import { Box, Chip, Link, Typography } from '@mui/material';
import React from 'react';
import { clientEnvVars } from '@/common/environment/clientEnvVars';

export function formatDuration(hours: number): string {
  // Keep in sync with backend formatDurationHours / durationTextSql.
  if (hours < 1) return `${Math.round(hours * 60)}m`;
  const h = Math.floor(hours);
  const m = Math.round((hours - h) * 60);
  return m > 0 ? `${h}h ${String(m).padStart(2, '0')}m` : `${h}h`;
}

/** Vertically centers renderCell content while left-aligning horizontally. */
export function GridCell({ children }: { children: React.ReactNode }) {
  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      {children}
    </Box>
  );
}

export function ProductChip({ value }: { value: string | null }) {
  return (
    <GridCell>
      {value ? (
        <Chip
          label={value}
          size="small"
          variant="outlined"
          sx={{ fontWeight: 500 }}
        />
      ) : (
        <Typography variant="caption" color="text.disabled">
          —
        </Typography>
      )}
    </GridCell>
  );
}

export function LifecycleChip({ value }: { value: string | null }) {
  return (
    <GridCell>
      {value ? (
        <Chip label={value} size="small" color="primary" />
      ) : (
        <Typography variant="caption" color="text.disabled">
          —
        </Typography>
      )}
    </GridCell>
  );
}

export const CARRIER_POLICY_COLUMN_HEADER = 'CARRIER POLICY NUMBER';

export function CarrierPolicyLink({
  applicationId,
  carrierPolicyNumber,
  termPolicyId,
}: {
  applicationId: number;
  carrierPolicyNumber: string | null;
  termPolicyId?: number;
}) {
  const trimmed = carrierPolicyNumber?.trim();
  const label = trimmed || (termPolicyId != null ? String(termPolicyId) : '—');
  return (
    <GridCell>
      <Link
        variant="body2"
        fontWeight={500}
        target="_blank"
        rel="noopener noreferrer"
        href={`/${clientEnvVars().NORA_SUBDIR}/applications/${applicationId}`}
      >
        {label}
      </Link>
    </GridCell>
  );
}
